// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__7Zq6b","bigColWidth":"Table_bigColWidth__17gms","biggerColWidth":"Table_biggerColWidth__3KRak","row":"Table_row__2KDU3","col":"Table_col__1TpJn"};